import { HashRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Game from './screens/Game';
import Classement from './screens/Classement';
import Greffier from './screens/Greffier';
import PlancheQR from './screens/PlancheQR';

export default function App() {
  return (
    <HashRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: '#FFFFFF',
            color: '#3C3C3C',
            border: '1px solid #2B3A63',
            borderRadius: '12px',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '15px',
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Game />} />
        <Route path="/classement" element={<Classement />} />
        <Route path="/ecran" element={<Classement grand />} />
        <Route path="/greffier" element={<Greffier />} />
        <Route path="/qr" element={<PlancheQR />} />
      </Routes>
    </HashRouter>
  );
}
